import React from 'react';
import logo from '../../logoNew.png';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faBars, faSignOutAlt } from '@fortawesome/free-solid-svg-icons';
import { useAuth } from '../../context/AuthContext';
import { Link } from 'react-router-dom';

const getInitials = (name = '') => {
    const initials = name
        .split(' ')
        .filter(Boolean)
        .slice(0, 2)
        .map((part) => part[0])
        .join('');

    return initials || 'U';
};

const Header = ({ isMobile, onToggleSidebar }) => {
    const { logout, user, role } = useAuth();

    const handleLogOut = () => {
        logout();
    };

    return (
        <header className="app-header">
            <div className="header-left">
                <button
                    type="button"
                    className="sidebar-toggle-button"
                    aria-label={isMobile ? 'Open navigation' : 'Toggle navigation'}
                    onClick={onToggleSidebar}
                >
                    <FontAwesomeIcon icon={faBars} />
                </button>
                <Link to="/" className="header-logo-link">
                    <img src={logo} alt="We Soda" className="header-logo" />
                </Link>
            </div>

            <div className="header-right">
                <div className="header-user-summary">
                    <span className="header-user-avatar">{getInitials(user?.name)}</span>
                    <span className="header-user-copy">
                        <span className="header-user-name">{user?.name || 'User'}</span>
                        <span className="header-user-email">{user?.username}</span>
                    </span>
                    {role && <span className="header-role-badge">{role}</span>}
                </div>
                <button type="button" className="header-logout-button" onClick={handleLogOut} title="Logout">
                    <FontAwesomeIcon icon={faSignOutAlt} />
                </button>
            </div>
        </header>
    );
};

export default Header;
